import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Master
import MasterReducer from './master/reducer';

// Authentication
import AuthReducer from './auth/reducer'
//Brands
// import BrandListReducer from "./brand/list/reducer";
// import BrandDataReducer from './brand/reducer';

//Users
// import UserListReducer from "./users/list/reducer"
// import UserDataReducer from "./users/reducer"
// import UserBrandsReducer from "./users/brands/reducer";
import { collaborationsReducer } from "./collaborations/reducer";
import legacyCollaborationsReducer from "./legacy-collaborations/reducer";

//Campaigns
import CampaignsReducer from "./campaigns/reducer";
import CampaignDetailsReducer from "./campaigns/details/reducer";
import CampaignRequirementsReducer from "./campaigns/requirements/reducer";
import CampaignCreativesReducer from "./campaigns/creatives/reducer";
import CampaignMilestonesReducer from "./campaigns/milestones/reducer";
import CampaignApplicationsReducer from "./campaigns/applications/reducer";
import CampaignCollaborationsReducer from "./campaigns/collaborations/reducer";
import CampaignInsightsReducer from "./campaigns/insights/reducer";
import CampaignPerformanceReducer from "./campaigns/performance/reducer";
import CampaignPostsReducer from "./campaigns/posts/reducer";
import CampaignRecommendedCreatorsReducer from "./campaigns/recommended-creators/reducer";
import CampaignInvitesReducer from "./campaigns/invites/reducer";

import InfluencersReducer from "./influencer/reducer";
// import CollaborationMilestoneReducer from "./campaigns/collaborations/milestones/reducer";
import UIReducer from "./ui/reducer";
import AddressBookReducer from "./addressBook/reducer";
import { campaignsActivityReducer } from "./campaigns/activity/reducer";
import { permalinkFilesReducer } from "./collaborations/files/reducer";
import collaborationDeletionRequestsReducer from "./collaboration-deletion-requests/reducer";
import invitesReducer from "./invites/reducer";

const rootReducer = combineReducers({
    permalinkFiles: permalinkFilesReducer,
    Layout: LayoutReducer,
    // master: MasterReducer,
    auth: AuthReducer,
    collaborations: collaborationsReducer,
    // brandList: BrandListReducer,
    // brandData: BrandDataReducer,
    // userList: UserListReducer,
    // userData: UserDataReducer,
    // userBrands: UserBrandsReducer,
    campaigns: CampaignsReducer,
    campaignRequirements: CampaignRequirementsReducer,
    campaignCreatives: CampaignCreativesReducer,
    campaignDetails: CampaignDetailsReducer,
    campaignMilestones: CampaignMilestonesReducer,
    campaignApplications: CampaignApplicationsReducer,
    campaignCollaborations: CampaignCollaborationsReducer,
    campaignInsights: CampaignInsightsReducer,
    campaignPerformance: CampaignPerformanceReducer,
    campaignPosts: CampaignPostsReducer,
    campaignRecommendedCreators: CampaignRecommendedCreatorsReducer,
    campaignInvites: CampaignInvitesReducer,
    master: MasterReducer,
    influencers: InfluencersReducer,
    ui: UIReducer,
    legacyCollaborations: legacyCollaborationsReducer,
    // collaborationMilestones: CollaborationMilestoneReducer,
    addressBook: AddressBookReducer,
    campaignsActivity:campaignsActivityReducer,
    collaborationDeletionRequests: collaborationDeletionRequestsReducer,
    invites: invitesReducer,
});

export default rootReducer;